import { faCommentDots } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

const Round = styled.button<{ raised?: boolean }>`
  position: fixed;
  right: 24px;
  /* Lyfts över verkställ-baren när den visas, så att knappen inte täcker Verkställ. */
  bottom: ${({ raised }) => (raised ? '84px' : '24px')};
  z-index: 20;
  width: 52px;
  height: 52px;
  border: none;
  border-radius: 50%;
  background: rgb(30, 90, 160);
  color: #fff;
  font-size: 22px;
  cursor: pointer;
  box-shadow: 0 3px 8px rgb(0 0 0 / 25%);
  transition: bottom 0.15s ease, transform 0.1s ease;

  &:hover {
    transform: scale(1.06);
    background: rgb(25, 75, 135);
  }
`;

interface Props {
  raised?: boolean;
  onClick(): void;
}

const FeedbackButton: React.FC<Props> = ({ raised, onClick }) => (
  <Round
    aria-label="Skicka feedback på ruttplaneringen"
    onClick={onClick}
    raised={raised}
    title="Skicka feedback på ruttplaneringen"
    type="button"
  >
    <FontAwesomeIcon icon={faCommentDots} />
  </Round>
);

export default FeedbackButton;
